import React from 'react';
import { Route, SearchFilters } from '../types';
import { extractRegions, extractCrags } from '../utils';

interface RegionCragFilterProps {
  routes: Route[];
  filters: SearchFilters;
  onFiltersChange: (filters: Partial<SearchFilters>) => void;
}

export default function RegionCragFilter({
  routes,
  filters,
  onFiltersChange,
}: RegionCragFilterProps) {
  const regions = extractRegions(routes);
  const crags = extractCrags(routes, filters.region);

  const handleRegionChange = (region: string) => {
    // When region changes, clear crag selection
    onFiltersChange({
      region: region || undefined,
      crag: undefined,
    });
  };

  const handleCragChange = (crag: string) => {
    onFiltersChange({
      crag: crag || undefined,
    });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Region Filter */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Filter by Region
        </label>
        <select
          value={filters.region || ''}
          onChange={(e) => handleRegionChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
        >
          <option value="">All Regions</option>
          {regions.map((region) => (
            <option key={region} value={region}>
              {region}
            </option>
          ))}
        </select>
      </div>

      {/* Crag Filter */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Filter by Crag
        </label>
        <select
          value={filters.crag || ''}
          onChange={(e) => handleCragChange(e.target.value)}
          disabled={!filters.region}
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
        >
          <option value="">All Crags{filters.region ? ` in ${filters.region}` : ''}</option>
          {crags.map((crag) => (
            <option key={crag} value={crag}>
              {crag}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
